var render = function render(){
  var _vm$eventFlowLocation;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex",
    attrs: {
      "id": "location-header"
    }
  }, [_c('div', {
    staticClass: "timeline-location-header",
    class: {
      'w-100': !((_vm$eventFlowLocation = _vm.eventFlowLocations) !== null && _vm$eventFlowLocation !== void 0 && _vm$eventFlowLocation.length)
    }
  }), _vm._l(_vm.eventFlowLocations, function (eventFlowLocation, index) {
    return _c('event-flow-location-name', {
      key: `grid-location-name-${eventFlowLocation.id}`,
      attrs: {
        "event-flow-location": eventFlowLocation,
        "index": index,
        "is-last": index == _vm.eventFlowLocations.length - 1
      }
    }, [_c('div', {
      staticClass: "d-flex"
    }, _vm._l(eventFlowLocation.eventFlowTopics, function (eventFlowTopic) {
      return _c('div', {
        key: `event-flow-dropzone-location-${eventFlowLocation.id}-topic-${eventFlowTopic.id}`,
        staticClass: "fake-topic"
      }, _vm._l(eventFlowTopic.items, function (eventFlowItem) {
        return _c('div', {
          key: `event-flow-item-${eventFlowItem.id}`,
          staticClass: "fake-item",
          class: {
            'fake-item-extended': _vm.extraFunctionFormData.showTime || _vm.extraFunctionFormData.showBrief
          }
        });
      }), 0);
    }), 0)]);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }